<div class="container d-flex justify-content-center align-items-center min-vh-100">
  <div class="card shadow p-4 w-100" style="max-width: 1200px; min-height: 750px;">
    <div class="card-header text-center">
      <h3 class="membership-title">CONSULTA TUS PUNTOS ACUMULADOS</h3>
    </div>
    <div class="card-body text-center d-flex flex-column align-items-center mt-5">
      <div class="w-100 mb-3">
        <div class="input-group">
          <input
            type="text"
            class="form form-control input-membership-search"
            [(ngModel)]="customerCI"
            placeholder="Número de carnet"
          />
          <button type="button" class="btn btn-membership-search" (click)="searchPoints()">
            <i class="fas fa-search me-2"></i>Buscar
          </button>
        </div>
      </div>
      <div class="w-100">
        <p class="app-alert-danger"> {{ errors }} </p>
      </div>
      <div *ngIf="showResult" class="mt-5">
        <h1 class="membership-text-body mb-4">HOLA {{customerName}}!</h1>
        <h1 class="membership-points">
          <span class="fs-2">Tienes </span> {{points}} <span class="fs-2">Pts.</span>
        </h1>
      </div>
    </div>
  </div>
</div>